import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';

import BackendService from '../services/backendService';
import { generateUniqueId } from '../utils/general';
import { useMetrics } from './useMetrics';

export const useImportPresentation = () => {
  const client = useQueryClient();
  const metrics = useMetrics();
  const { mutate: upload, isError, isLoading, isSuccess, reset, data } = useMutation(
    async ({
      file,
      templateId,
      onUploadProgress,
    }: {
      file: File;
      templateId: string;
      onSuccessFunction?: () => void;
      onUploadProgress?: (event: any) => void;
    }) => {
      const fileId = generateUniqueId().toString();
      const filePath = `${fileId}_${file.name}`;
      const data = await BackendService.instance.getUploadUrl(`game_files/${filePath}`);
      const url = data.data;
      await axios.request({
        url,
        method: 'PUT',
        timeout: 60 * 1000,
        headers: {
          'Content-Type': file?.type,
        },
        data: file,
        onUploadProgress: onUploadProgress && onUploadProgress,
      });
      const fileTypes = file.name.split('.');
      const fileType = fileTypes[fileTypes.length - 1];

      const newSlides = await BackendService.instance.gameFiles.importPresentation(
        templateId,
        filePath,
        fileType,
      );

      return newSlides;
    },
    {
      onSuccess: (data, { templateId, onSuccessFunction }) => {
        if (onSuccessFunction) {
          onSuccessFunction();
        }
        const templateCacheKey = ['template', templateId];
        client.invalidateQueries(templateCacheKey);
        metrics.logEvent('Creator.Import.Presentation.Success', { templateId });
      },
    },
  );

  return {
    upload,
    isUploading: isLoading,
    isSuccess: isSuccess,
    isError,
    uploadedSlides: data,
    reset,
  };
};
